module.exports = __webpack_public_path__ + "static/media/delete_icon.07928042.svg";